import { render, staticRenderFns } from "./searchItem.vue?vue&type=template&id=b90e4fd2&scoped=true"
import script from "./searchItem.vue?vue&type=script&lang=js"
export * from "./searchItem.vue?vue&type=script&lang=js"
import style0 from "./searchItem.vue?vue&type=style&index=0&id=b90e4fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90e4fd2",
  null
  
)

export default component.exports